// Google Analytics event tracking utilities

/**
 * Check if user has consented to analytics cookies
 * @returns {boolean} - True if consent is granted
 */
const hasConsent = () => {
  if (typeof window === 'undefined') return false;
  const consent = localStorage.getItem('cookieConsent');
  return consent === 'accepted';
};

/**
 * Track a custom event in Google Analytics
 * Only tracks if user has given consent
 * @param {string} eventName - Name of the event (e.g., 'vendor_click')
 * @param {object} eventParams - Additional parameters for the event
 */
export const trackEvent = (eventName, eventParams = {}) => {
  // Only track if consent is granted
  if (!hasConsent()) {
    console.log('[Analytics] Event not tracked - no consent:', eventName);
    return;
  }

  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
};

/**
 * Track when a vendor is clicked
 * @param {string} vendorName - Name of the vendor
 * @param {string} vendorUrl - URL of the vendor
 * @param {number} vendorPriority - Priority/position of the vendor
 */
export const trackVendorClick = (vendorName, vendorUrl, vendorPriority = null) => {
  trackEvent('vendor_click', {
    vendor_name: vendorName,
    vendor_url: vendorUrl,
    vendor_priority: vendorPriority,
    event_category: 'engagement',
    event_label: vendorName,
  });
};

/**
 * Track page views (optional - GA4 does this automatically)
 * @param {string} pageTitle - Title of the page
 * @param {string} pagePath - Path of the page
 */
export const trackPageView = (pageTitle, pagePath) => {
  trackEvent('page_view', {
    page_title: pageTitle,
    page_path: pagePath,
  });
};

/**
 * Track contact form submissions
 * @param {string} formName - Name of the form
 */
export const trackFormSubmission = (formName) => {
  trackEvent('form_submission', {
    form_name: formName,
    event_category: 'engagement',
  });
};

/**
 * Track outbound link clicks
 * @param {string} url - Destination URL
 * @param {string} linkText - Text of the link
 */
export const trackOutboundLink = (url, linkText) => {
  trackEvent('outbound_link', {
    link_url: url,
    link_text: linkText,
    event_category: 'engagement',
  });
};

